import React, { createContext, useContext, useState, useEffect } from 'react';

const LangContext = createContext(null);

export function LangProvider({ children }) {
  // Ten sam wzorzec anty-hydratacyjny co ThemeContext.jsx (11.08): initial state ZAWSZE 'pl',
  // nigdy nie czyta localStorage synchronicznie przy pierwszym renderze - react-snap prerenderuje
  // kazda strone z pustym localStorage (zawsze 'pl'), wiec pierwszy render klienta musi dac ten sam
  // wynik co zamrozony HTML. Prawdziwa zapisana preferencja wczytywana DOPIERO w useEffect ponizej.
  const [lang, setLang] = useState('pl');

  useEffect(() => {
    const stored = localStorage.getItem('ga_lang');
    if (stored && stored !== 'pl') setLang(stored);
  }, []);

  useEffect(() => {
    localStorage.setItem('ga_lang', lang);
  }, [lang]);

  const toggleLang = () => setLang(l => (l === 'pl' ? 'en' : 'pl'));

  return (
    <LangContext.Provider value={{ lang, setLang, toggleLang }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
